import script from "./ml-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ml-dialog.vue?vue&type=script&setup=true&lang=js"

import "./ml-dialog.vue?vue&type=style&index=0&id=53eb4bc8&lang=scss"

const __exports__ = script;

export default __exports__